import { FC, useState } from "react";
import ClientReview from "./ClientReview";
import { useIntl } from "react-intl";
import { useMutation, useQuery } from "@tanstack/react-query";
import { queryKeys } from "../../../services/react-query/queryKeys";
import { getLocationReviews } from "../../../network/location";
import { useSelector } from "react-redux";
import Empty from "../../common/Empty";
import { deleteReview } from "../../../network/settings";
import { message } from "antd";
import DeleteModal from "../../common/DeleteModal";

interface ClientsReviewsProps {}

const ClientsReviews: FC<ClientsReviewsProps> = ({}) => {
  const [selectedReview, setSelectedReview] = useState<any>(null);
  const { locationId } = useSelector(
    (state: { calendar: { locationId: number | null } }) => state.calendar
  );
  // const [params, setParams] = useState({
  //   page: 1,
  // });
  const {
    data: reviewsList,
    isLoading,
    isError,
    refetch,
  } = useQuery([queryKeys?.reviewsList, locationId], () =>
    getLocationReviews(locationId)
  );

  const intl = useIntl();

  return (
    <div className="py-12 px-8 bg-[#EEF0FF] space-y-3 ">
      <div className="space-y-3">
        <h2 className="text-2xl text-color-primary">
          {intl.formatMessage({
            id: "customer_ratings_title",
          })}{" "}
        </h2>
        <p className="text-[#75757E]">
          {intl.formatMessage({
            id: "customer_ratings_description",
          })}{" "}
        </p>
      </div>
      <div className="p-4 space-y-2 max-h-[700px] overflow-auto">
        {reviewsList?.data?.length ? (
          reviewsList?.data?.map((review: any) => (
            <ClientReview
              key={review.id}
              review={review}
              setSelectedReview={setSelectedReview}
            />
          ))
        ) : (
          <Empty
            title={intl.formatMessage({ id: "noReviews" })}
            subTitle={intl.formatMessage({ id: "noReviews" })}
          />
        )}
      </div>
      <DeleteModal
        data={selectedReview?.rateable?.location_id}
        optionalParam2={selectedReview?.id}
        confirmationHeader={intl.formatMessage({
          id: "delete_review_confirmation_header",
        })}
        confirmationText=""
        onClose={() => setSelectedReview(null)}
        onDelete={deleteReview}
        successMessage={intl.formatMessage({
          id: "reviewDeleted",
        })}
        visible={!!selectedReview}
        afterDelete={() => refetch()}
      />
    </div>
  );
};

export default ClientsReviews;
